export enum MentorDevelopmentAreaKey {
	GOALS_SETTING = 'goalsSetting',
	GIVING_FEEDBACK = 'givingFeedback',
	LISTENING_SKILLS = 'listeningSkills',
	QUESTIONING_SKILLS = 'questioningSkills',
	COMMUNICATION_SKILLS = 'communicationSkills',
	RELATION_MANAGEMENT = 'relationManagement',
	MENTOR_DEVELOPMENT = 'mentorDevelopment',
}

export enum MentorDevelopmentCategoryKey {
	READING = 'reading',
	PREPARATION = 'preparation',
	PRACTICE = 'practice',
	REFLECTION = 'reflection',
}

export enum MentorDevelopmentStageKey {
	FIRST = 'first',
	SECOND = 'second',
	STANDARD = 'standard',
	PENULTIMATE = 'penultimate',
	LAST = 'last',
}

export enum MentorDevelopmentAction {
	MENTOR_REPORT = 'mentorReport',
	CONTRACT = 'contract',
	ARTICLE = 'article',
	MENTEE_PLAN = 'menteePlan',
}

export type MentorDevelopmentStepView = {
	id: number;
	stageKey: MentorDevelopmentStageKey;
	categoryKey: MentorDevelopmentCategoryKey;
	sequence: number;
	label: string;
	articleId: number | null;
	action: MentorDevelopmentAction | null;
	achieved: boolean;
};

export type MentorDevelopmentStepTranslated = MentorDevelopmentStepView & {
	text: string | null;
	isFallback: boolean;
	hasTranslation: boolean;
	fallbackLanguageCode: string | null;
};

export type MentorDevelopmentAreaView = {
	areaKey: MentorDevelopmentAreaKey;
	sequence: number;
	initialScore: number | null;
	finalScore: number | null;
	selectedForDevelopment: boolean;
	steps: MentorDevelopmentStepTranslated[];
};

export type MentorDevelopmentAreaComputed = MentorDevelopmentAreaView & {
	title: string;
	info: { about: string; value: string };
};

export type MentorDevelopmentGetResponse = MentorDevelopmentAreaView[];

export type UpdateMentorDevelopmentAreaItem = {
	areaKey: MentorDevelopmentAreaKey;
	initialScore?: number | null;
	finalScore?: number | null;
	selectedForDevelopment?: boolean;
};

export type UpdateMentorDevelopmentAreasRequest = {
	areas: UpdateMentorDevelopmentAreaItem[];
};

export type UpdateMentorDevelopmentAreasResponse = MentorDevelopmentGetResponse;

export type ToggleMentorDevelopmentAreaResponse = {
	areaKey: MentorDevelopmentAreaKey;
	selectedForDevelopment: boolean;
};

export type ToggleMentorDevelopmentStepResponse = {
	id: number;
	stepDefinitionId: string;
	achieved: boolean;
};

export type MentorDevelopmentGroupedSteps = Array<{
	stageKey: MentorDevelopmentStageKey;
	categories: Array<{
		categoryKey: MentorDevelopmentCategoryKey;
		steps: MentorDevelopmentStepTranslated[];
	}>;
}>;

export type UpdateMentorDevelopmentScoreRequest = { initialScore: number } | { finalScore: number };

export type UpdateMentorDevelopmentScoreResponse = {
	areaKey: MentorDevelopmentAreaKey;
	initialScore: number;
	finalScore: number;
	selectedForDevelopment: boolean;
};

export type MentorDevelopmentProgressSummaryStepKey =
	| 'currentCompetencyAssessment'
	| 'selectedDevelopmentAreas'
	| 'developmentPlanExecution'
	| 'finalCompetencyAssessment';

export type MentorDevelopmentProgressSummaryResponse = {
	activeStep: number;
	steps: Array<{
		key: MentorDevelopmentProgressSummaryStepKey;
		enabled: boolean;
	}>;
};
